export default __webpack_public_path__ + "c2744d17be23d7b0bca771c462371ecd.png";